module.exports = __webpack_public_path__ + "img/tarot-major-arcana-04.90e5fa3d.png";